<template>
  <div
    class="mf-notes-wrapper"
   
  >
    
    <div v-if="isbracket" class="option-required-product">
      <img class="errorIcon" :src="errorIconSrc" />
      <div class="non-icon-option-required-product-text">
        Requires: {{ MfProductcount }}
        <NBS />
        <a
          v-if="MfProductUrl"
          :href="MfProductUrl"
          :class="'required-product-link ' + analyticsClassRequiredProduct"
          target="_blank"
          rel="noopener noreferrer"
          v-bind="dataAttributeOptionRequiredProduct"
        >
          {{ qryvalue }}
        </a>
        <span v-else>
          {{ qryvalue }}
        </span>
        <NBS /> per
        {{ mfsku }}
      </div>
      <div class="Mfnote-Padding"></div>
    </div>
  </div>
</template>
<script>
import ProductOptionService from "../../services/ProductOptionService";
import { mapGetters } from "vuex";
import NBS from "../shared/NonBreakingSpace.vue";
export default {
  name: "ProductOptionsModal",
  props: {
    styleData: Array
  },
  data() {
    return {
      isbracket: false,
      MfProductcount: null,
      MfProductUrl: null,
      mfquerystring: null,
      mfsku: null,
      qryvalue: null
    };
  },
  created() {
    // check query string
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const qrybracket = urlParams.get("bracket") ? urlParams.get("bracket") : "";

    if (qrybracket != "") {
      const [manufacturer, model] = qrybracket.split("|");
      this.qryvalue = qrybracket.toUpperCase();
      ProductOptionService.getMFnotes(
        manufacturer,
        model,
        this.getProductSku.SkuCode
      )
        .then(res => res.data)
        .then(products => {
          if (products.ProductUrl && products.RequiresProductCode) {
            this.MfProductUrl =
              products.ProductUrl != "#" ? products.ProductUrl : "";
            this.mfsku = products.ProductCode;
            this.MfProductcount = products.RequiresProductQuantity;
            this.qryvalue = products.RequiresProductCode;
            this.isbracket = true;
          } else {
            this.isbracket = false;
          }
        })
        .catch(() => {
          // to handle error
          this.MfProductUrl = null;
          this.mfsku = null;
          this.isbracket = false;
        });
    } else {
      return;
    }
  },
  computed: {
    ...mapGetters("product", ["getProductSku"]),    
    errorIconSrc() {
      return "https://res.cloudinary.com/avd/image/upload/v1661964419/Icons/New%20Design%20Site%20Icons/error.svg";
    },
    iconColor() {
      return "color:" + this.styleData[0].IconColor;
    },
    leadTimeIcon() {
      if (
        this.styleData[0].SAPStatusCode == 99 ||
        this.styleData[0].SAPStatusCode == 0
      ) {
        return "leadTimeIcon-Chat";
      } else {
        return "leadTimeIcon";
      }
    },   
    isIE() {
      return window.navigator.userAgent.indexOf("Trident/") > -1;
    }    
    
  },
  
  components: { NBS },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.mf-notes-wrapper {
 padding-bottom: 24px;
  margin-bottom: 25px;
  @include media-breakpoint-up(sm) {
    margin-bottom: 0;
    border-bottom: 0;
  }
}
.option-required-product {
  @include hdg();
  @include body_small();
  display: flex;
  align-items: center;
  background-color: $warning-200;
  border: 1px solid $warning;
  min-height: 50px;
  padding-left: 16px;
  padding-right: 16px;
  min-width: 100%;
  margin-top: 8px;
  @media (min-width: $lg-tablet) {
    min-width: 100%;
    max-width: max-content;
  }
}

.required-product-link {
  text-decoration: underline;
  color: $primary;
  &:hover {
    color: $primary-300;
  }

  &:focus {
    color: $primary-300;
    @include focus_outline();
  }
}

.errorIcon {
  margin-right: 8px;
}
.non-icon-option-required-product-text {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 6px;
  margin-top: 6px;
  color: #262626;
}
.Mfnote-Padding {
  padding-bottom: 24px;
}
</style>
